import { type AppStore, setupStore } from "~/app/store";

// Seems to be caused by some kind of circular dependency...
let store: AppStore | null = null;

// Augment window for Storybook store injection
declare global {
  interface Window {
    __STORY_STORE__?: AppStore;
  }
}

/**
 * Get the Redux store instance.
 *
 * ⚠️ TEMPORARY WORKAROUND:
 * In Storybook, this returns window.__STORY_STORE__ if set, allowing stories
 * to preload product data before component render. This is needed because
 * ProductService.getBaseProductData() directly accesses this singleton store.
 *
 * This workaround should be removed once ProductService.getBaseProductData
 * is deprecated and all callers are migrated to use hooks or pass data explicitly.
 * See: docs/plans/deprecate-getBaseProductData.md
 */
export function getStore(): AppStore {
  // TEMPORARY: Storybook can inject a pre-populated store
  // Remove this check once ProductService.getBaseProductData is retired
  if (typeof window !== "undefined" && window.__STORY_STORE__) {
    return window.__STORY_STORE__;
  }

  if (!store) {
    store = setupStore();
  }
  return store;
}
